import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Pet } from "@/types";

export const petsQueryKey = ["pets"] as const;

// `select` narrows what a caller re-renders on: react-query structurally shares
// the selected result, so unchanged slices keep the same reference across polls.
export function useGetPets<TData = Pet[]>({
  select,
}: { select?: (pets: Pet[]) => TData } = {}) {
  return useQuery({
    queryKey: petsQueryKey,
    select,
    queryFn: async () => {
      const path = "pets";
      const res = await guacHttpClient.get<Pet[], HttpResponse<Pet[]>>(path);
      return res.data;
    },
    // Keep other staffers' pets and coin balances fresh in the playyard.
    refetchInterval: 60_000,
  });
}
